import {
  Box,
  makeStyles,
} from "@material-ui/core";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import ICIPAdminService from "../../../../../services/ICIPAdminService";
import raffleDrawEntryService from "../../../../../services/RaffleDrawEntryService";

import { Tabs } from "antd";
import { FirstUserVerify } from "./winners-validation/FirstUserVerify";
import { SecondUser } from "./winners-validation/SecondUser";
import { ThirdUser } from "./winners-validation/ThirdUser";
import GeneralSettingService from "../../../../../services/GeneralSettingService";

const useStyles = makeStyles((_) => ({
  generalGrid: {
    padding: 10,
  },
  specialBox: {
    padding: 10,
  },
}));

interface RaffleDrawsWinnersListProps {}

export const RaffleDrawsWinnersList = (props: RaffleDrawsWinnersListProps) => {
  const classes = useStyles(props);
  const [loading, setLoading] = useState(false);
  const [raffleDrawInProgress, setRaffleDrawInProgress] = useState({});
  const [winnersTable, setWinnersTable] = useState([]);
  const [winnersCountTable, setWinnersCountTable] = useState([]);
  const [error, setError] = useState(false);
  const [settings, setSettings] = useState({});
  const [tab, setTab] = useState(() => "1");
  const intl = useIntl();

  const { TabPane } = Tabs;

  const loadRaffleDrawInProgress = () => {
    setLoading(true);
    ICIPAdminService.getRaffleDrawInProgress().then((response) => {
      if (response.isSuccess && response.data.code === 100) {
        const data = JSON.parse(JSON.stringify(response.data.data));
        const numberOfWinners = +data["raffleDrawInProgress"][
          "number_of_winners"
        ];
        setRaffleDrawInProgress(data["raffleDrawInProgress"]);
        let countTable = [];
        let currentWinnersTable = data["winners"];
        for (let index = 0; index < numberOfWinners; index++) {
          countTable.push(index);
          if (currentWinnersTable.length < index + 1)
            currentWinnersTable.push("");
        }
        setWinnersCountTable(countTable);
        setWinnersTable(currentWinnersTable);
      }
      setLoading(false);
    });
  };

  const fetchGeneralSettings = () => {
    GeneralSettingService.getGeneralSettings().then((response) => {
      if (response.isSuccess) {
        switch (response.data.code) {
          case 100:
            const settings = JSON.parse(JSON.stringify(response.data.data));
            setSettings(settings);
            break;
          case 110:
            setError(true);
            console.log(error);
            break;
        }
      } else {
        setError(true);
      }
      //setLoading(false);
    });
  };

  useEffect(() => {
    loadRaffleDrawInProgress();
    fetchGeneralSettings();
  }, []);

  return (
    <>
      <Box component="div">
        <Box component="div">
          <Tabs
            defaultActiveKey={tab}
            centered
            onChange={(current) => setTab(current)}
          >
            <TabPane
              tab={intl.formatMessage({ id: "sharedScreen.firstUser" })}
              key="1"
            >
              {tab === "1" ? (
                <Box component="div">
                  <Box component="div">
                    <FirstUserVerify
                      settings={settings}
                      raffleDraw={raffleDrawInProgress}
                    />
                  </Box>
                </Box>
              ) : (
                <></>
              )}
            </TabPane>
            <TabPane
              tab={intl.formatMessage({ id: "sharedScreen.secondUser" })}
              key="2"
            >
              {tab === "2" ? (
                <Box component="div">
                  <Box component="div">
                    <SecondUser
                      settings={settings}
                      raffleDraw={raffleDrawInProgress}
                    />
                  </Box>
                </Box>
              ) : (
                <></>
              )}
            </TabPane>
            <TabPane
              tab={intl.formatMessage({ id: "sharedScreen.thirdUser" })}
              key="3"
            >
              {tab === "3" ? (
                <Box component="div">
                  <Box component="div">
                    <ThirdUser
                      settings={settings}
                      raffleDraw={raffleDrawInProgress}
                    />
                  </Box>
                </Box>
              ) : (
                <></>
              )}
            </TabPane>
          </Tabs>
        </Box>
      </Box>
    </>
  );
};

export default RaffleDrawsWinnersList;
